module.exports = __webpack_public_path__ + "static/media/jazz.24296e4a.JPG";